import axios from "axios";
import queryString from 'query-string';
import Joi from 'joi-browser';
import { APIAddress } from "constants/config";

const STATES = ['not_scheduled', "all_not_archived", "archived", "enrolled", "all"]

export default function getAllStudent(schoolId, state) {

  if(!schoolId){
    return new Promise((resolve, reject) => {
      reject({
        error: new Error('Missing school ID')
      })
    })
  }

  if(STATES.indexOf(state) == -1){
    return new Promise((resolve, reject) => {
      reject({
        error: new Error(`Invalid states: please enter one of the following states: ${STATES.toString()}`)
      })
    })
  }

  let sState = state == 'all' ? '' : '?sState=' + STATES.indexOf(state);

	return new Promise((resolve, reject) => {
		axios.put(APIAddress, {'uri': `/g_schstdtlist/${schoolId}${sState}`,
    'method': 'GET',
    'token': localStorage.getItem('token')})
		.then((res) => {
			resolve(res);
		})
		.catch((err) => {
			reject(err);
		})
	})
}



// WEBPACK FOOTER //
// ./src/controllers/controllers/student/getAllStudent.js